export const themeData = {
  uber: {
    logo: require("@/assets/images/logos/uber.png"),
    primary: "#2196f3",
    secondary: "#1A1A1A",
    square: "#000",
    sideMenu: "#1A1A1A",
    sideMenuItemText: "#FFF",
    sideMenuActiveItemText: "#FFF",
    sideItemDivider: "#363638",
    sideMenuSubItemText: "#bbb",
    success: "#3bc95c",
    danger: "#f54d4d",
    warning: "#f99a41",
    info: "#2e96f3",
    black: "#1A1A1A",
    mainText: "#1A1A1A",
    button: "#FFF",
    background: "#FFF",
    chart: "#dbeddf",
    indigo: "#696d79",
    radioColor: "#000",
    sideMenuItems: [
      {
        divider: "Enterprise Licensing",
        title: "License Management",
        to: 'license-management',
        icon: 'mdi-calendar-text',
        customer: 'uber'
      },
    ]
  },
  ihg: {
    logo: require("@/assets/images/logos/ihg.png"),
    primary: "#2196f3",
    secondary: "#1F4455",
    square: "#1F4455",
    sideMenu: "#1F4455",
    sideMenuItemText: "#FFF",
    sideMenuActiveItemText: "#E8542C",
    sideItemDivider: "#363638",
    sideMenuSubItemText: "#bbb",
    success: "#3bc95c",
    danger: "#f54d4d",
    warning: "#f99a41",
    info: "#2e96f3",
    black: "#1A1A1A",
    mainText: "#1A1A1A",
    button: "#FFF",
    background: "#FFF",
    chart: "#dbeddf",
    indigo: "#696d79",
    radioColor: "#000",
    sideMenuItems: [
      {
        divider: "Enterprise Licensing",
        title: "License Management",
        to: 'license-management',
        icon: 'mdi-calendar-text',
        customer: 'ihg'
      },
    ]
  },
  demo: {
    logo: require("@/assets/images/logos/boundless-logo.png"),
    primary: "#2196f3",
    secondary: "#1A1A1A",
    square: "#000",
    sideMenu: "#1A1A1A",
    sideMenuItemText: "#FFF",
    sideMenuActiveItemText: "#FFF",
    sideItemDivider: "#363638",
    sideMenuSubItemText: "#bbb",
    success: "#3bc95c",
    danger: "#f54d4d",
    warning: "#f99a41",
    info: "#2e96f3",
    black: "#1A1A1A",
    mainText: "#1A1A1A",
    button: "#FFF",
    background: "#FFF",
    chart: "#dbeddf",
    indigo: "#696d79",
    radioColor: "#000",
    sideMenuItems: [
      {
        divider: "Enterprise Licensing",
        title: "License Management",
        to: 'license-management',
        icon: 'mdi-calendar-text',
        customer: 'demo'
      },
    ]
  },
  default: {
    logo: require("@/assets/images/logos/boundless-logo.png"),
    primary: "#2196f3",
    secondary: "#1A1A1A",
    square: "#000",
    sideMenu: "#1A1A1A",
    sideMenuItemText: "#FFF",
    sideMenuActiveItemText: "#FFF",
    sideItemDivider: "#363638",
    sideMenuSubItemText: "#bbb",
    success: "#3bc95c",
    danger: "#f54d4d",
    warning: "#f99a41",
    info: "#2e96f3",
    black: "#1A1A1A",
    mainText: "#1A1A1A",
    button: "#FFF",
    background: "#FFF",
    chart: "#dbeddf",
    indigo: "#696d79",
    radioColor: "#000",
    sideMenuItems: [
      {
        divider: "Enterprise Licensing",
        title: "License Management",
        to: 'license-management',
        icon: 'mdi-calendar-text',
      },
    ]
  },
}
